import React from "react";
import { SVGAsset } from "res";

/**
 * @function FaceIDView
 * @returns {React.Component}
 * @exported true
 * @description This is the view that is shown when the user clicks the "Face ID". This is shown above the login inputs and is only supported in captures.
 */
export default function FaceIDView(props) {
  return(
    // remove "hide" class to show for captures
    <div className="face-id-view flex-height flex-container flex-vertical space-around hide">
      <div className="flex-container flex-horizontal align-center set-height header-text-container">
        <h3 className="flex-width">Set up Face ID</h3>
        <SVGAsset className="set-width clickable" id="XIcon" />
      </div>
      <div className="text-container flex-height">
        <p className="description-text">You can now use Face ID instead of your password to log in. To set up:</p>
        <ol className="face-id-steps">
          <li>Log in</li>
          <li>Go to profile &#x3e; Profile Updates &#x3e; Biometric Enrollment</li>
        </ol>
      </div>
    </div>
  );
}